export const siteData = {
    name: 'Structure Lab',
    description: 'Admin panel for Structure Lab',
    img: '/img/logo.svg',
}